module.exports = __webpack_public_path__ + "img/sg--217.prt.ccc4816c.jpg";